import { AbstractControl } from '@angular/forms';
import { isValid, parse } from 'date-fns';
import {
  convertTimezoneToLocal,
  isNullOrEmpty,
} from '../../core/utils/common-functions';

export interface ParsedIdentityInfo {
  birthdate?: Date;
  gender?: '1' | '2';
  isParseSuccess: boolean; // 轉換是否成功
}

/** 解析 MY 身分證 */
function parseMalaysiaIdentity(identityNo: string): ParsedIdentityInfo | null {
  if (isNullOrEmpty(identityNo)) {
    return { isParseSuccess: false };
  }

  const regString = /^[0-9]{12}$/;
  if (!regString.test(identityNo)) {
    return { isParseSuccess: false };
  }

  // 年份依「> 50 => 19xx，否則 20xx」
  const yy = parseInt(identityNo.substr(0, 2), 10);
  const yearPrefix = yy > 50 ? '19' : '20';
  const year = `${yearPrefix}${identityNo.substr(0, 2)}`;

  // 取中間四碼作為 MMDD
  const monthDate = identityNo.substr(2, 4);
  const resultDate = year + monthDate; // yyyyMMdd

  // 以 date-fns parse + isValid 驗證日期
  const birthdate = parse(resultDate, 'yyyyMMdd', new Date());
  if (!isValid(birthdate)) {
    return { isParseSuccess: false };
  }

  const gender = parseInt(identityNo.charAt(11), 10) % 2 === 0 ? '2' : '1';

  return { birthdate, gender, isParseSuccess: true };
}

/**
 * 檢核 idNo 控制項目前是否為「可用狀態」。
 *
 * 傳回值語義：
 * - true  = 控制項存在，且目前不是 invalid（可能是 VALID 或 PENDING）。
 * - false = 控制項不存在，或目前為 invalid（有驗證錯誤）。
 */
export function isIdentityNoControlValid(
  identityNoCtrl: AbstractControl | null | undefined
): boolean {
  if (!identityNoCtrl) return false;

  // 先刷新驗證狀態；若該欄位 invalid 則不做
  identityNoCtrl.updateValueAndValidity?.({ onlySelf: true, emitEvent: false });
  return identityNoCtrl.invalid !== true;
}

/** 從 MY 身份證解析並轉換成預設值 */
export function extractDefaultBirthdateAndSexualForMY(identityNo: string): {
  birthdate?: Date;
  gender?: '1' | '2';
} {
  const parsed = parseMalaysiaIdentity(identityNo);
  if (!parsed || !parsed.isParseSuccess) return {};

  const result: any = {};

  if (parsed.birthdate) {
    // 日期元件 Issue
    result.birthdate = convertTimezoneToLocal(parsed.birthdate, false);
  }
  if (parsed.gender) {
    result.gender = parsed.gender;
  }

  return result;
}
